import { classes } from "lib/actions/util";
import { ButtonProps } from "react-html-props";

export default function CloseButton({
  className,
  ...rest
}: Omit<ButtonProps, "children">) {
  return (
    <button
      type="button"
      className={classes(
        "rounded-md text-lg leading-none text-gray-400 hover:text-gray-600",
        className,
      )}
      {...rest}
    >
      &#x2715;
    </button>
  );
}
